import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/list/deleted${`?query=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/list/deleted`;

export const URL = (searchText: string): RouteDefinition => `${baseRoute}/list/deleted?query=${searchText}`;
